// 验证密码（长度至少8位，至少包含数字、英文大小写、特殊符号其中两种）
export function validPassword(password) {
  const reg =
    /^(?![\d]+$)(?![a-zA-Z]+$)(?![~!@#$%^&*.]+$)[\da-zA-Z~!@#$%^&*.]{8,}$/;
  return reg.test(password);
}

// 密码正则（长度至少8位，包含数字、英文大写和英文小写）
export const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;

// 登录密码正则 （长度至少8位，至少包含数字、英文大小写、特殊符号其中两种）
export const passwordLoginReg =
  /^(?![\d]+$)(?![a-zA-Z]+$)(?![~!@#$%^&*.]+$)[\da-zA-Z~!@#$%^&*.]{8,}$/;
// 验证正整数
export function validNumber(number) {
  const reg = /^\d+$/;
  return reg.test(number);
}

// 正整数正则
export const numberReg = /^\d+$/;

// 验证非零正整数
export function validNonZeroNumber(number) {
  const reg = /^[1-9]\d*$/;
  return reg.test(number);
}

// 验证金额
export function validMoney(money) {
  const reg = /^([0-9][0-9]*)+(.[0-9]{1,2})?$/;
  return reg.test(money);
}

// 验证金额 不能为零最多两位小数
export function validMoneyNew(money) {
  const reg = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;
  return reg.test(money);
}

// 验证金额可以为负数
export function validMoneyWithNegative(money) {
  const reg = /^-?[0-9]+(\.[0-9]{1,2})?$/;
  return reg.test(money);
}

// 金额正则
export const moneyReg = /^([0-9][0-9]*)+(.[0-9]{1,2})?$/;

// 0-100的整数的正则（包含0和100）
export const percentageReg = /^\d{1,2}|100$/;

// 验证0-100的整数（包含0和100）
export function validPercentage(number) {
  const reg = /^(\d{1,2}|100)$/;
  return reg.test(number);
}

// 验证 纯数字（8或10位） 或者 数字加字母大小写（8位）
export function validCardNumber(number) {
  const reg = /^(\d{10})$|^(\d{8})$|^([0-9A-Za-z]{8})$/;
  return reg.test(number);
}
